import { render, staticRenderFns } from "./StatusView.vue?vue&type=template&id=2a8de750&scoped=true&"
import script from "./StatusView.vue?vue&type=script&lang=js&"
export * from "./StatusView.vue?vue&type=script&lang=js&"
import style0 from "./StatusView.vue?vue&type=style&index=0&id=2a8de750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8de750",
  null
  
)

export default component.exports